import React from 'react';
import PropTypes from 'prop-types';

export default function TableSlice(props) {
    const {
        rows
    } = props;

    if (!rows) return ''

    return (
        <div className="container">
            <table className="table table-hover">
                <tbody>
                    {rows && rows.map((row, index) => {
                        if (index === 0) return (
                            <tr key={index}>
                                <th>{row.left_text}</th>
                                <th>{row.right_text}</th>
                            </tr>
                        )
                        return (
                            <tr key={index}>
                                <td>{row.left_text}</td>
                                <td>{row.right_text}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}
TableSlice.propTypes = {
    content: PropTypes.shape({
        title: PropTypes.string,
        text_align: PropTypes.string,
        type: PropTypes.string,
        button_url: PropTypes.string,
        button_title: PropTypes.string,
        description: PropTypes.arrayOf(PropTypes.object),
    })
}



// WEBPACK FOOTER //
// src/client/components/slices/TableSlice.js